import { flow } from 'fp-ts/lib/function'

import { AutomationsPresentationV1 } from 'Automations/automationEditor'
import {
  ConductorWorkflow,
  createConductorWorkflow
} from 'Automations/nodeDefinitions/conductor'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'
import { getStartNode } from '../getStartNode'
import {
  applyConditionalProperties,
  applyInputMapping,
  applyOutputMapping,
  intermediateNodeArrayToTaskDefinitions,
  transformNodeGraphToIntermediateNodeArray
} from './steps'

export const presentationToConductorWorkflow = ({
  name,
  description,
  presentation,
  definitions
}: {
  name: string
  description?: string
  presentation: AutomationsPresentationV1
  definitions: ResolvedNodeDefinitions
}): ConductorWorkflow =>
  createConductorWorkflow({
    name,
    description,
    inputParameters: getWorkflowInputParameters(presentation, definitions),
    // Conditional properties are read from the resolved registry (already
    // concrete), so the whole transform is one synchronous `flow`. Each step is
    // partially applied with `definitions` first, keeping the pipeline
    // point-free.
    tasks: flow(
      transformNodeGraphToIntermediateNodeArray(definitions),
      applyConditionalProperties(definitions),
      applyOutputMapping(definitions),
      applyInputMapping(definitions),
      intermediateNodeArrayToTaskDefinitions(definitions, presentation.nodes)
    )(presentation)
  })

const getWorkflowInputParameters = (
  presentation: AutomationsPresentationV1,
  definitions: ResolvedNodeDefinitions
): string[] => {
  const startNode = getStartNode(presentation, definitions)
  if (!startNode || !startNode.type) {
    throw new Error('valid start node is missing')
  }

  const definition = definitions[startNode.type as NodeType]
  if (!definition) throw new Error('Start node definition not found')

  return definition.startNodeInputParameters ?? []
}
